import {
  adminActions,
  chatActions,
  notificationActions,
  paymentActions,
  pharmacistActions,
  pharmacyActions,
  userActions,
  utilActions,
} from '../actions';
import actionTrackerList from './actionTrackerList';

const filterItems = [
  pharmacyActions.addFavourite,
  pharmacyActions.removeFavourite,
  pharmacistActions.addFavourite,
  pharmacistActions.removeFavourite,
  pharmacistActions.getPostedShifts,
  pharmacistActions.watchlist,
  pharmacistActions.deleteWatchlist,
  adminActions.adminPharmacistPictures,
  adminActions.getActiveUsers,
  userActions.logos,
  adminActions.getAdminProfile,
  adminActions.getAdminSettings,
  adminActions.getAdminInfo,
  chatActions.addGroupChannelMetadata,
  adminActions.getAdminPicture,
  pharmacistActions.picture,
  paymentActions.getBookingStatus,
  pharmacyActions.getProfessionalPictures,
];
const filteredActionTracker = actionTrackerList.filter(
  (item) => !filterItems.includes(item)
);

const actionTracker = [
  ...filteredActionTracker,
  notificationActions.getNotificationsListPagination,
  notificationActions.markAsRead,
  pharmacistActions.incomeReports,
  pharmacistActions.incomeDetails,
  notificationActions.getNotificationLoad,
  utilActions.publicRatePharmacist,
  utilActions.publicRatePharmacy,
  utilActions.publicRateProfessional,
  utilActions.getPublicPharmacistRatingItems,
  utilActions.getPublicPharmacyRatingItems,
];

export default actionTracker;
